import "../../assets/css/pocket_peace.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";
import ProductAuthModal from "../../components/modal/product_auth_modal";

import { useSearchParams, useNavigate } from "react-router-dom";
import { useDonationModal } from "../../hooks/use_donation_modal";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useSubSalesValidation } from "../../hooks/use_sub_sales_validation";
import educlipMainKids from "../../assets/images/educlip/educlip_main_kids.png";
import pocketPeaceBanner from "../../assets/images/pocket_peace/banner.png";
import yellowMonster from "../../assets/images/educlip/yellow_monster.png";
import { useEffect, useState } from "react";

import SisaConsentModal from "../../components/modal/sisa_consent_modal";
import GeulpicConsentModal from "../../components/modal/geulpic_consent_modal";
import SisaThirdPartyModal from "../../components/modal/sisa_third_party_modal";
import GeulpicThirdPartyModal from "../../components/modal/geulpic_third_party_modal";
import { serialNumberVerify } from "../../api/pocket_peace";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function PocketPeacePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const kdBusiness = searchParams.get("kd_business");
  const encSerial = searchParams.get("encSerial");
  const userRef = searchParams.get("usridx");

  const donationModal = useDonationModal();

  useSubSalesValidation(kdBusiness);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalStep, setModalStep] = useState(0); // 0: 닫힘, 1: 첫번째 동의, 2: 두번째 동의, 3: ProductAuthModal
  const [isProductAuthModalOpen, setIsProductAuthModalOpen] = useState(false);

  const courses = {
    sale: [
      {
        category: "시사원정대",
        title: "시사원정대 1년 정기구독 40% 할인",
        description: "정가 130,800원 --> 78,000원",
        subDescription: "",
        detail: [],
        price: "78,000원",
        tag: "VAT 포함",
        productSeq: "1",
        productType: "sisa",
      },
      {
        category: "글픽",
        title: "글픽 1년 정기구독 40% 할인",
        description: "정가 175,000원 --> 105,000원",
        subDescription: "",
        detail: [],
        price: "105,000원",
        tag: "VAT 포함",
        productSeq: "2",
        productType: "geulpic",
      },
    ],
  };

  const features = [
    {
      title: "시사원정대는?",
      description: `국내 최대 초등 일간신문 '어린이동아'의 교육전문 기자가
        만드는 주니어 잡지<br />
        신문처럼 빠르고, 게임만큼 재밌고 백과사전보다 유익한 배경지식으로 가득한 초등생을 위한 시사논술 월간지입니다.`,
    },
    {
      title: "글로보는 이슈픽 글픽",
      description: `초등 문해력 걱정마! 글픽이 잡아줄게!<br />
        ✅ 최신 시사 뉴스로 배경지식 쑥쑥<br />
        ✅ 교과 연계 비문학 독해력 강화<br />
        ✅ 어휘력, 속담•사자성어까지 한번에<br />
        ✅ 토론형 찬반 이슈로 사고력, 표현력 UP!`,
    },
    {
      title: "시사원정대 환불규정",
      description: `<span>•</span> 상품불량 발견 시 수령 후 7일 이내 환불 가능합니다.<br />
        <span>•</span> 고객과실로 인한 손상(낙서, 찢어짐)의 경우 <br />환불 불가합니다.<br />
        <span>•</span> 환불은 해지의 통지가 도달한 시점을 기준으로 발송한 권수와 사은품 대금을 정가로 차감한 후 잔액을 환불합니다.<br />
        ※ 예시: 환불금액 = <br />&nbsp;&nbsp;결제금액 - (정가 10,900원 x 발송권 수) - 사은품 정가`,
    },
    {
      title: "글픽 환불규정",
      description: `<span>•</span> 환불은 해해지 신청 기점을 기준으로 발송한 호수의 정가<br />&nbsp;&nbsp;+배송비를 차감한 후 잔액을 환불합니다.<br />
        <span>•</span> 예시: 환불금액 = 총 납부금액<br />
              &nbsp;&nbsp;(권당 정가 X 발송호 수량) - 총 배송비`,
    },
    {
      title: "대표고객센터 1833-3503",
      description: `콘텐츠 저작권은 동아일보 교육법인<br />
        (주)동아이지에듀에 있으며 무단 전재•복사•배포를 금합니다.`,
    },
  ];

  const slideContents = [
    {
      title: "발송 안내",
      description: `시사원정대 전월 25일 전후로 배송됩니다.
        시사원정대 배송은 2~6일 가량 소요됩니다.
        지역에 따라 차이가 있습니다.

        이사 또는 배송지 변경이 필요한 경우, 22일전에 구독센터 (1833-3503)으로 주소지 변경 신청을 해야합니다.`,
    },
    {
      title: "발송 안내",
      description: `글픽은 매주 월요일 발송됩니다.
        글픽 배송은 2~5일 가량 소요됩니다.
        신청 호수의 학습주간 전에 수령할 수 있습니다. 

        이사 또는 기타 사유로 배송지를 변경할 경우, 고객센터
        (1833-3503)에서 신청할 수 있습니다.`,
    },
  ];

  const faqs = [
    {
      question: "환불은 가능한가요?",
      answer:
        "네, 포켓피스 환불 규정에 따라 진행됩니다.<br /><a href='https://pocketpeace.com/service#refund' target='_blank'>[환불정책 바로가기]</a> 자세한 환불정책을 확인하실 수 있습니다.",
    },
    {
      question: "글로보는 이슈픽 글픽",
      answer: `초등 문해력 걱정마! 글픽이 잡아줄게!<br />
        ✅ 최신 시사 뉴스로 배경지식 쑥쑥<br />
        ✅ 교과 연계 비문학 독해력 강화<br />
        ✅ 어휘력, 속담•사자성어까지 한번에<br />
        ✅ 토론형 찬반 이슈로 사고력, 표현력 UP!`,
    },
    {
      question: "시사원정대 환불규정",
      answer: `
        <span>•</span> 상품불량 발견 시 수령 후 7일 이내 환불 가능합니다.<br />
        <span>•</span> 고객과실로 인한 손상(낙서, 찢어짐)의 경우 <br />환불 불가합니다.<br />
        <span>•</span> 환불은 해지의 통지가 도달한 시점을 기준으로 발송한 권수와 사은품 대금을 정가로 차감한 후 잔액을 환불합니다.<br />
        &nbsp;&nbsp;※ 예시: 환불금액 = <br />&nbsp;&nbsp;&nbsp;&nbsp;결제금액 - (정가 10,900원 x 발송권 수) - 사은품 정가
        `,
    },
    {
      question: "글픽 환불규정",
      answer: `
        <span>•</span> 환불은 해해지 신청 기점을 기준으로 발송한 호수의 정가<br />&nbsp;&nbsp;+배송비를 차감한 후 잔액을 환불합니다.<br />
        <span>•</span> 예시: 환불금액 = 총 납부금액<br />&nbsp;&nbsp;(권당 정가 X 발송호 수량) - 총 배송비
        `,
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slideContents.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + slideContents.length) % slideContents.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleCourseClick = (course) => {
    setSelectedProduct(course);
    setModalStep(1);
  };

  const handleFirstConsentNext = () => {
    setModalStep(2);
  };

  const handleSecondConsentNext = () => {
    setModalStep(0);
    setIsProductAuthModalOpen(true);
  };

  const handleCloseAllModals = () => {
    setModalStep(0);
    setSelectedProduct(null);
    setIsProductAuthModalOpen(false);
  };

  const handleProductAuthSuccess = (phoneNumber) => {
    setIsProductAuthModalOpen(false);

    if (selectedProduct?.productType === "geulpic") {
      navigate("/subscribe/geulpic", {
        replace: true,
        state: { fromPocketPeace: true, phoneNumber },
      });
    } else if (selectedProduct?.productType === "sisa") {
      navigate("/subscribe/sisa", {
        replace: true,
        state: { fromPocketPeace: true, phoneNumber },
      });
    }
  };

  useEffect(() => {
    const initPage = async () => {
      document.body.style.background = "white";

      if (encSerial) {
        try {
          SessionStorageUtil.setItem(
            "encSerial",
            decodeURIComponent(encSerial)
          );

          const verifyCheck = await serialNumberVerify();

          if (!verifyCheck) {
            navigate(-1);
          }
        } catch (error) {
          console.error("Serial number verification failed:", error);
        }
      } else {
        alert("잘못된 접근 방식입니다.");
        navigate(-1);
      }
    };

    initPage();
  }, [encSerial]);

  return (
    <div className="pocketpeace-container">
      <Header />

      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-badge">시사원정대 + 글픽</div>
            <h1 className="hero-title">
              SK텔레콤 ZEM폰 포켓피스
              <br />
              구매 고객 대상 이벤트!
            </h1>
            <p className="hero-description">시사원정대 + 글픽 할인 혜택</p>
          </div>
          <div className="hero-image">
            <img src={educlipMainKids} alt="포켓피스 이미지" />
          </div>
        </div>
      </section>

      <section className="course-section">
        <h2 className="section-title">교육•학습 콘텐츠</h2>

        {Object.entries(courses).map(([grade, items], index) => (
          <div key={grade} className="grade-section">
            <h3 className="grade-title">{"특가"}</h3>
            <div className="course-grid">
              {items.map((course, idx) => (
                <div
                  key={idx}
                  className="course-card"
                  onClick={() => handleCourseClick(course)}
                >
                  <span className="course-category">
                    <span>✦ {course.category}</span>
                  </span>
                  <h4 className="course-title">{course.title}</h4>
                  <div className="course-description-box">
                    <p className="course-description">{course.description}</p>
                    <p
                      className="course-subDescription"
                      style={{ marginBottom: "24px" }}
                    >
                      {course.subDescription}
                    </p>
                    {course.detail && course.detail.length > 0 && (
                      <p className="course-detail">
                        {Object.entries(course.detail).map(
                          ([key, value], index) => {
                            return <span key={key}>{value}</span>;
                          }
                        )}
                      </p>
                    )}
                  </div>
                  <div className="course-footer">
                    <span className="course-price">{course.price}</span>
                    <span className="course-tag">{course.tag}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      <section className="banner-section">
        <img src={pocketPeaceBanner} alt="배너" />
      </section>

      <section className="special-section">
        <div className="product-title">상품 안내</div>
        <div className="special-content">
          <div className="special-title-box">
            <div className="emoji-icon">
              <img src={yellowMonster} alt="이모지" />
            </div>
            <div className="special-circle"></div>

            <div className="slide-container">
              <div className="slide-content">
                <h2 className="special-title">
                  {slideContents[currentSlide].title}
                </h2>
                <p className="special-description">
                  {slideContents[currentSlide].description
                    .split("\n")
                    .map((line, idx) => (
                      <span key={idx}>
                        {line}
                        {idx <
                          slideContents[currentSlide].description.split("\n")
                            .length -
                            1 && <br />}
                      </span>
                    ))}
                </p>
              </div>

              <div className="slide-navigation">
                <button className="slide-btn prev" onClick={prevSlide}>
                  ‹
                </button>
                <div className="slide-dots">
                  {slideContents.map((_, index) => (
                    <span
                      key={index}
                      className={`dot ${
                        currentSlide === index ? "active" : ""
                      }`}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </div>
                <button className="slide-btn next" onClick={nextSlide}>
                  ›
                </button>
              </div>
            </div>
          </div>
          <div className="special-content-box">
            <ul className="special-list">
              {features.map((feature, idx) => (
                <li key={idx} className="special-item">
                  <div className="check-icon">✓</div>
                  <div className="special-item-content">
                    <h4>{feature.title}</h4>
                    <p
                      dangerouslySetInnerHTML={{ __html: feature.description }}
                    ></p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <Footer />

      {selectedProduct && selectedProduct.productType === "sisa" && (
        <>
          <SisaConsentModal
            isOpen={modalStep === 1}
            onClose={handleCloseAllModals}
            onNext={handleFirstConsentNext}
          />
          <SisaThirdPartyModal
            isOpen={modalStep === 2}
            onClose={handleCloseAllModals}
            onNext={handleSecondConsentNext}
          />
        </>
      )}

      {selectedProduct && selectedProduct.productType === "geulpic" && (
        <>
          <GeulpicConsentModal
            isOpen={modalStep === 1}
            onClose={handleCloseAllModals}
            onNext={handleFirstConsentNext}
          />
          <GeulpicThirdPartyModal
            isOpen={modalStep === 2}
            onClose={handleCloseAllModals}
            onNext={handleSecondConsentNext}
          />
        </>
      )}
      <ProductAuthModal
        isOpen={isProductAuthModalOpen}
        onClose={() => setIsProductAuthModalOpen(false)}
        onSuccess={handleProductAuthSuccess}
      />

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        userRef={userRef}
        paymentType="card"
      />
    </div>
  );
}

export default PocketPeacePage;
